import {createMemoryHistory} from 'history';

export const history = createMemoryHistory();

window.__historyObject = history;
